import React, { useEffect, useState } from "react";
import "./styles.scss";
import clsx from "clsx";
import { useGlobalContext } from "../shared/GlobalContext/context";

const Banner = (props) => {
  const { isPopup, children, size = "small", numberOfDays } = props;
  const [showPopup, setShowPopup] = useState(false);
  const { isCookyAccepted } = useGlobalContext();

  useEffect(() => {
    if (isPopup && isCookyAccepted) {
      const lastClosed = localStorage.getItem("lastClosed");
      const shouldShow =
        !lastClosed ||
        Date.now() - lastClosed > numberOfDays * 24 * 60 * 60 * 1000;
      setShowPopup(shouldShow);
    }
  }, []);

  const handleClose = () => {
    if (isPopup && isCookyAccepted) {
      localStorage.setItem("lastClosed", Date.now());
      setShowPopup(false);
    }
  };

  return isPopup && showPopup ? (
    <div
      className={clsx(
        "pop-up-banner flex-it flex-align-item-center flex-justify-center",
        size,
        isPopup && "full-popup-banner"
      )}
    >
      <div className="Banner">
        <div
          className="close-top flex-it flex-align-item-center flex-justify-end"
          onClick={() => handleClose()}
        >
          <div className="text-close flex-inline">Close</div>
        </div>
        {children}
      </div>
    </div>
  ) : (
    !isPopup && <div className={clsx("Banner", size)}>{children}</div>
  );
};

export default Banner;
